/**
 * 站点模式：备案完成后主站即为完整社区站。
 * 保留 withRealPrefix / isRealSite，便于旧链接与组件兼容。
 */
export function isRealSite(_pathname) {
  return true;
}

export function withRealPrefix(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return normalized;
}

/** 将历史 /real/* 路径映射到主站路径 */
export function stripRealPrefix(pathname) {
  if (pathname === '/real' || pathname === '/real/') return '/';
  if (pathname.startsWith('/real/')) {
    const rest = pathname.slice('/real'.length);
    return rest || '/';
  }
  return pathname;
}
